import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const CareerEdit = () => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [careerImg, setCareerImg] = useState(null);
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const { id } = useParams();

  // Fetch existing career data
  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/careerCategories/${id}`)
      .then((response) => {
        const data = response.data?.data;
        setName(data.name);
        setDescription(data.description);
        setCareerImg(data.careerImg); // Assuming this is a URL for the image
      })
      .catch((error) => {
        console.error("Error fetching career data:", error);
      });
  }, [API_BASE_URL, id]);

  // Navigate to Add Career page
  const handleAddNewCareer = () => {
    navigate("/add-career");
  };

  // Navigate to View All Careers page
  const handleViewAllCareer = () => {
    navigate("/all-career");
  };

  // Update career data
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Create a FormData object
    const formData = new FormData();
    formData.append("name", name);
    formData.append("description", description);
    if (careerImg && typeof careerImg !== "string") {
      formData.append("careerImg", careerImg); // Add file only if it's updated
    }

    const role = localStorage.getItem("role");
    const endpoint =
      role === "subAdmin"
        ? `${API_BASE_URL}/subadmin/careerCategories/${id}`
        : `${API_BASE_URL}/admin/careerCategories/${id}`;

    try {
      // Send PUT request to update career
      const response = await axios.put(
        endpoint,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      alert("Career updated successfully");
      console.log("Career updated successfully:", response.data);

      // Navigate to All Career page after successful update
      navigate("/all-career");
    } catch (error) {
      alert("Error updating career");
      console.error(
        "Error updating career:",
        error.response?.data || error.message
      );
    }
  };

  return (
    <>
      <div id="add-subject-inner-wrapper">
        <div className="superheader">
          <div className="subjectHeaderdiv">
            <h5>Career</h5>
            <div className="subjectdiv2">
              <button className="handleNewSubject" onClick={handleAddNewCareer}>
                + Add New Career
              </button>
              <button className="allSubjects" onClick={handleViewAllCareer}>
                All Career
              </button>
            </div>
          </div>

          <div className="form-sub-container mt-4" id="form">
            <h4 className="subject-detail">Edit Career Details</h4>
            <form
              className="subject-detail-form"
              encType="multipart/form-data"
              onSubmit={handleSubmit}
            >
              <div className="input-group">
                <div style={{ paddingBottom: "10px" }}>
                  <label className="label">Title : </label>
                </div>
                <input
                  type="text"
                  placeholder="Enter Title"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>

              <div className="input-group">
                <div style={{ paddingBottom: "10px" }}>
                  <label className="label">Description : </label>
                </div>
                <input
                  type="text"
                  placeholder="Enter Description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  required
                />
              </div>

              <div className="input-group">
                <div style={{ paddingBottom: "10px" }}>
                  <label className="label">Image : </label>
                </div>
                <input
                  type="file"
                  id="subject-upload-icon"
                  multiple={false}
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      setCareerImg(file); // Update with the new file
                    }
                  }}
                />
                {careerImg && typeof careerImg === "string" && (
                  <div style={{ marginTop: "10px" }}>
                    <img
                      src={`${API_BASE_URL}/uploads/${careerImg}`}
                      alt="Career"
                      style={{ width: "150px", height: "auto" }}
                    />
                  </div>
                )}
              </div>

              <div className="school-subj-form-btns">
                <button
                  className="btn-search"
                  type="submit"
                  onClick={handleSubmit}
                >
                  Save
                </button>
                <button
                  className="btn-cancel"
                  type="button"
                  onClick={() => navigate("/all-career")}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default CareerEdit;
